import React, { useState } from "react";
import AuditTable from "./AuditTable";
import DataDeletion from "./DataDeletion";
import styles from "../../_css/SecurityCompliance.module.css";



function Index({ defaultTab = 'audit' }) {
    const [selectedTab, setSelectedTab] = useState(defaultTab);

    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    };

    const getTabButtonClass = (tab) => {
        return `${styles.tabButton} ${selectedTab === tab ? styles.tabButtonActive : styles.tabButtonInactive
            }`;
    };

    return (
        <div className={styles.Indexcontainer}>
            <div className={styles.tabContainer}>
                <button
                    onClick={() => handleTabChange("audit")}
                    className={getTabButtonClass("audit")}
                >
                    Audit Table
                </button>

                <button
                    onClick={() => handleTabChange("delete")}
                    className={getTabButtonClass("delete")}
                >
                    Data Deletion
                </button>
            </div>

            <div className={styles.dataContainer}>
                {selectedTab === "audit" ? (
                    <AuditTable />
                ) : (
                    <DataDeletion />
                )}
            </div>
        </div>
    );
}

export default Index;